import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'ma-modale-avviso',
	templateUrl: './modale-avviso.component.html',
})
export class ModaleAvvisoComponent implements OnInit {
	constructor(public modal: NgbActiveModal) {}

	message = 'Message';
	close = 'Annulla';

	ngOnInit() {}
}

/**
 *
 * @param modalService
 * @param message
 * @param button
 * @param buttonClass btn-save | btn-delete | btn-success
 * @param close
 * @returns
 */
export function modaleAvviso(modalService: NgbModal, message: string, close = 'Chiudi'): Promise<boolean> {
	const modal = modalService.open(ModaleAvvisoComponent, { size: 'md' });
	modal.componentInstance.message = message;
	modal.componentInstance.close = close;
	return modal.result;
}
